import React from "react";
// core components
import { Col, Row } from 'reactstrap';

import uniqBy from 'lodash/uniqBy';

import { Link } from 'react-router-dom';

import { IoMdCheckmark, IoMdRemove, IoIosSearch } from 'react-icons/io'
import { FaFileUpload, FaFolderPlus } from 'react-icons/fa';
import { connect } from 'react-redux'
import PropTypes from "prop-types";
import { bindActionCreators }  from 'redux';
import queryString from 'query-string';

import RightSidebar from '../RightSidebar';

import commonStyle from "commonStyle";

import { formatter } from "utils";

import Button from "components/Button";
import Spacer from "components/Spacer";
import ScrollView from 'components/ScrollView';

import { getDeletedObjects } from "api/actions";

import { withoutAuth, withSearch } from "HOC"

import {
  GET_DELETED_OBJECTS,
  GET_DELETED_OBJECTS_SUCCESS,
  GET_DELETED_OBJECTS_FAILURE,
  RESTORE_OBJECTS,
  RESTORE_OBJECTS_SUCCESS,
  RESTORE_OBJECTS_FAILURE,
} from '../../../constants/ActionTypes'

import './index.css'
import TruncateLine from "components/TruncateLine";

import TableRow from 'components/TableRow';


export default class MainView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      hoveringOver: null,
      page: 0,
      selections: [],
      loading: false,
    };
  }

  async componentWillReceiveProps(props) {
    const refresh = this.state.search !== props.location.search;

    if (props.hasOwnProperty('objects')) {
      await this.addObjects(props.objects);
    }

    const newState = {
      loading: props.loading,
      page: props.objects.length > 0 ? this.state.page + 1 : this.state.page
    };

    switch (props.type) {
      case RESTORE_OBJECTS:
        await this.startLoading();
        break;
      case RESTORE_OBJECTS_SUCCESS:
        await this.stopLoading();

        this.removeRestoredData(props.restoredIds);
        break;
      case RESTORE_OBJECTS_FAILURE:
        await this.stopLoading();
        this.removeRestoredData(props.restoredIds);

        const errors = props.errors || [];

        const duplicateErrors = errors.filter(error => error.duplicate);

        const regularErrors = errors.filter(error => !error.duplicate);

        const duplicateErrorsData = this.getDataFromIds(duplicateErrors.map(error => error.id));

        const regularErrorsData = this.getDataFromIds(regularErrors.map(error => error.id));

        duplicateErrorsData.map(data => this.props.addNotification({
          level: 'error',
          autoDismiss: 10,
          children: this.errorNotification(data.item, 'has a duplicate in it\'s destination bucket.')
        }))

        regularErrorsData.map(data => this.props.addNotification({
          level: 'error',
          autoDismiss: 7,
          children: this.errorNotification(data.item, 'could not be restored.')
        }))

        break;
    }

    if (refresh) {
      newState.data = [];
      newState.search = props.location.search;
      newState.page = 0;
    }

    this.setState(newState, () => {
      if (refresh) {
        const prefix = props.location.search ? queryString.parse(props.location.search).prefix : '';
        this.fetchMore(0, { prefix });
      }
    });
  }

  componentWillMount() {
    const { page } = this.state;

    const prefix = this.props.location.search ? queryString.parse(this.props.location.search).prefix : '';
    this.setState({
      search: this.props.location.search,
      data: [],
    });
    this.props.getDeletedObjects({ page, prefix });
  }

  errorNotification = (item, message) => (
    <div>
      <p style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 600 }}>{item}</span> {message}
      </p>
    </div>
  )

  removeRestoredData = (restoredIds = []) => {
    const { selections = [], data = [] } = this.state;

    if (restoredIds.length === 0) return;

    const restoredData = data.filter(object => restoredIds.includes(object.id))

    this.setState({
      data: data.filter(object => !restoredIds.includes(object.id)),
      selections: selections.filter(selection => !restoredIds.includes(selection))
    });

    // Show notification
    restoredData.map(
      data => {
        const pathParts = data.path.split('/');
        pathParts.pop();
        let pathWithoutFile = pathParts.join('/');

        let linkToFile = null;

        if (!pathWithoutFile) {
          linkToFile = `/dashboard`;
          pathWithoutFile = 'root_directory';
        } else {
          linkToFile = `/dashboard?prefix=${pathWithoutFile}`;
        }

        this.props.addNotification({
        level: 'success',
        autoDismiss: 10,
        children: (
          <div>
            <p>
              <span style={{ fontWeight: 400 }}>{data.item}</span> was restored to
              <Link to={linkToFile}> {pathWithoutFile}</Link>
            </p>
          </div>
        )
      })
      });
  }

  addObjects = (objects = []) => new Promise((resolve) => {
    if (objects.length > 0) {
      let objs = this.state.data;

      objs = objs.concat(objects);
      objs = uniqBy(objs, info => info.id);

      this.setState({
        data: objs,
      }, resolve);
    } else {
      resolve();
    }
  });

  getDataFromIds = (ids = []) => this.state.data.filter(data => ids.includes(data.id)) || [];

  removeItem  = (id) => new Promise((resolve) => {
    const { data, selections } = this.state;
    this.setState({
        data: data.filter(data => data.id !== id),
        selections: selections.splice(selections.indexOf(id), 1)
      }, resolve);
  });

  fetchMore = (page, options = {}) => {
    if (!this.state.loading) {
      const prefix = this.props.location.search ? queryString.parse(this.props.location.search).prefix : '';
      this.props.getDeletedObjects({ page, prefix: options.prefix || prefix });
    }
  };

  updateSelections = updatedSelections => new Promise(resolve => {
    this.setState({
      selections: updatedSelections
    }, () => {
      const { onSelectionsUpdate } = this.props;

      onSelectionsUpdate && onSelectionsUpdate();

      resolve();
    })
  });

  renderNoData = () => {
    if (this.props.loading) {
      return null;
    } else {
      return (
        <div className={'empty-bucket'}>
          <h3>No deleted files found</h3>
          <p>Any file deleted from the dashboard can be found here</p>
        </div>
      )
    }
  }

  startLoading = () => new Promise(resolve => this.setState({ loading: true }, resolve));

  stopLoading = () => new Promise(resolve => this.setState({ loading: false }, resolve));

  renderTable = ({ data, oneSelected, multipleSelected, allSelected }) => (
    <table
      style={{
        width: '100%',
      }}
    >
      <thead>
        <tr
          onMouseOver={() => {
            this.setState({
              hoveringOver: 'rowHead'
            })
          }}
          onMouseLeave={() => {
            this.setState({
              hoveringOver: null
            })
          }}
        >
          <td>
            {this.state.hoveringOver === 'rowHead' &&
              <div
                className={'checkbox'}
                onClick={async (e) => {
                  e.stopPropagation();

                  if (oneSelected || multipleSelected) {
                    await this.updateSelections([]);
                  } else {
                    await this.updateSelections(this.state.data.map(info => info.id));
                  }
                }}
              >
                { this.state.hoveringOver === 'rowHead' && !(oneSelected || multipleSelected) && <h6 style={{}}><IoMdCheckmark /></h6> }
                { this.state.hoveringOver === 'rowHead' && (oneSelected || multipleSelected) && <h6 ><IoMdRemove /></h6> }
              </div>
            }
          </td>
          <td>
            <p className={'tableHead'}>Name</p>
          </td>
          <td>
            <p className={'tableHead'}>Date deleted</p>
          </td>
          <td>
            <p className={'tableHead'}>Size</p>
          </td>
        </tr>
      </thead>
      <tbody>
      {
        data.map(info => {
          const { id, starred } = info;
          const isSelected = this.state.selections.indexOf(id) !== -1;
          const isStarred = starred;

          return (
            <TableRow
              canStar={false}
              canPreview={false}
              hideLastModified={true}
              hidePath={false}
              hideDateDeleted={false} 
              key={info.id}
              onMouseOver={() => {
                this.setState({
                  hoveringOver: id
                })
              }}
              onMouseLeave={() => {
                this.setState({
                  hoveringOver: null
                })
              }}
              onCheckbox={async () => {
                let _selections = this.state.selections;

                const containsItem = _selections.includes(id);

                if (containsItem) {
                  _selections.splice(_selections.indexOf(id), 1);
                } else {
                  _selections.push(id);
                }

                await this.updateSelections(_selections);
                this.forceUpdate()
              }}
              onSelect={async () => {
                await this.updateSelections([id]);
              }}
              isStarred={isStarred}
              isSelected={isSelected}
              onView={() => {
                this.props.showPreview && this.props.showPreview(id)
              }}
              {...info}
            />
          )
        })
      }
      </tbody>
    </table>
  )

  onRestore = () => {
    if (this.props.restoreObjects) {
      this.props.restoreObjects({ ids: this.state.selections })
    }
  }

  render() {
    const { data } = this.state;

    const hasData = data.length > 0;

    const oneSelected = this.state.selections.length === 1;
    const multipleSelected = this.state.selections.length > 1;
    const allSelected = this.state.selections.length === this.state.data.length;
    const anySelected = oneSelected || multipleSelected;


    return (
      <div style={{ marginLeft: 10, position: 'absolute', bottom: 0, left: 0, right: 0, top: 15 }}>
        <Row
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            top: 0
          }}
        >
          <Col
            xs={12}
            sm={12}
            md={anySelected ? 9 : 12}
          >
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
              }}
            >
              <ScrollView
                gap={0.5}
                onBottom={() => {
                  const { page } = this.state;

                  this.fetchMore(page);
                }}
                className={'table-col'}
              >
                {hasData ?
                  this.renderTable({ data, oneSelected, multipleSelected, allSelected })
                  :
                  this.renderNoData()
                }
              </ScrollView>
            </div>
          </Col>
          {anySelected &&
            <Col
              xs={12}
              sm={12}
              md={3}
              className={'table-col'}
            >
              <RightSidebar
                oneSelected={oneSelected}
                multipleSelected={multipleSelected}
                allSelected={allSelected}
                onRestore={this.onRestore}
              />
            </Col>
          }
        </Row>
        <div className={`loader-container ${this.props.loading || this.state.loading ? 'loading-show' : 'loading-hide'}`}>
          <div className="loader"></div>
        </div>
      </div>
    );
  }
}

MainView.defaultProps = {
  objects: []
};